import Box from '@mui/material/Box';
import { node, object, string } from 'prop-types';
import React from 'react';
import { LINK_PREVIEW_MIN_WIDTH_PX } from '../messageBubbleMaxWidth';

/**
 * Layout-only clamp. The `_preview` file is always `fit: inside` (never cropped).
 * 3:1 / 1:3 is the keep-ratio window; past that `cover` clips the card, not the file.
 */
export const linkPreviewImageSx = {
  display: 'block',
  margin: '0 auto',
  width: 'auto',
  height: 'auto',
  maxWidth: '100%',
  maxHeight: 'min(400px, 300cqi)',
  minWidth: LINK_PREVIEW_MIN_WIDTH_PX,
  minHeight: 'calc(100cqi / 3)',
  objectFit: 'cover',
  objectPosition: 'center',
  cursor: 'pointer',
  borderRadius: 0,
};

const classes = {
  picture: linkPreviewImageSx,
};

const Image = ({ src = null, sx = {}, fallback = null, ...rest }) => {
  if (!src?.startsWith('https://')) {
    return fallback;
  }

  return (
    <Box
      component="img"
      alt="preview"
      className={classes.picture}
      src={src}
      sx={{
        ...classes.picture,
        ...sx,
      }}
      {...rest}
    />
  );
};

Image.propTypes = {
  src: string,
  sx: object,
  fallback: node,
};

export default Image;
